import { render, staticRenderFns } from "./wap.vue?vue&type=template&id=21addd64&scoped=true"
import script from "./wap.vue?vue&type=script&lang=js"
export * from "./wap.vue?vue&type=script&lang=js"
import style0 from "./wap.vue?vue&type=style&index=0&id=21addd64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21addd64",
  null
  
)

export default component.exports